import { AuthRoute } from './auth-route';
import { AuthenticatedRoute } from './authenticated-route';
import { BillingRoute } from './billing-route';
import { DashboardDetailedRoute, DashboardRoute } from './dashboard-route';
import { IndexRoute } from './index-route';
import { OnboardingRoute } from './onboarding-route';
import { PrivacyRoute } from './privacy-route';
import { ProfileRoute } from './profile-route';
import { ProjectRoute } from './project-route';
import { rootRoute } from './root';
import { TermsRoute } from './terms-route';

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  AuthRoute,
  AuthenticatedRoute.addChildren([
    OnboardingRoute,
    DashboardRoute,
    DashboardDetailedRoute,
    ProjectRoute,
    ProfileRoute,
    BillingRoute,
  ]),
  TermsRoute,
  PrivacyRoute,
]);
